import React from "react";
import {
	Box,
	Grid,
	Typography,
	TextField,
	Autocomplete,
	Checkbox,
	Tooltip,
	ListItemText,
	LinearProgress,
} from "@mui/material";
import { alpha } from "@mui/system";
import { HeadphonesOutlined } from "@mui/icons-material";

export default function AtendimentosSection({
	theme,
	labelErp,
	selectedAtendimentosServices,
	setSelectedAtendimentosServices,
	atendimentosSortedOptions,
	setAtendimentosSortedOptions,
	atendimentosIsOpen,
	setAtendimentosIsOpen,
	atendimentosInputValue,
	setAtendimentosInputValue,
	allServiceClient,
	allSelectedAtendimentos,
	displayedAtendimentosValue,
	getSortedOptions,
	loadingServices,
}) {
	const handleOpen = () => {
		setAtendimentosIsOpen(true);
		if (Array.isArray(allServiceClient) && allServiceClient?.length > 0) {
			setAtendimentosSortedOptions(
				getSortedOptions(
					[
						{ id_cliente_servico: "ALL", nome: "Selecionar todos os serviços" },
						...allServiceClient,
					],
					selectedAtendimentosServices,
				),
			);
		}
	};

	const handleClose = () => {
		setAtendimentosIsOpen(false);
		setAtendimentosInputValue("");
	};

	const handleChange = (_, value) => {
		if (value.some((v) => v?.id_cliente_servico === "ALL")) {
			setSelectedAtendimentosServices(
				allSelectedAtendimentos ? [] : allServiceClient,
			);
			return;
		}
		setSelectedAtendimentosServices(value);
	};

	return (
		<Box
			sx={{
				p: 2,
				bgcolor: theme.palette.background.paper,
				borderRadius: "12px",
				width: "100%",
				mb: 1,
			}}
		>
			{/* Cabeçalho */}
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
				<Box
					sx={{
						backgroundColor: alpha(theme.palette.primary.main, 0.2),
						borderRadius: "10px",
						width: "35px",
						height: "35px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<HeadphonesOutlined
						fontSize="small"
						sx={{
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.light
									: theme.palette.primary.dark,
						}}
					/>
				</Box>
				<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
					Atendimentos — {labelErp}s
				</Typography>
			</Box>

			<Box
				sx={{
					border: "1px solid",
					borderColor: theme.palette.divider,
					pb: 2,
					pl: 2,
					pr: 2,
					borderRadius: "12px",
					mt: 2,
				}}
			>
				<Grid container spacing={1} sx={{ mt: 1, alignItems: "center" }}>
					<Grid item xs={12}>
						<Tooltip
							title={
								selectedAtendimentosServices.length > 1 ? (
									<Box sx={{ maxHeight: 200, overflowY: "auto", p: 1 }}>
										{selectedAtendimentosServices?.map((s) => (
											<div key={s?.id_cliente_servico}>
												{s?.id_cliente_servico} — {s?.nome}
											</div>
										))}
									</Box>
								) : (
									""
								)
							}
							placement="top"
							arrow
						>
							<Autocomplete
								multiple
								fullWidth
								disableCloseOnSelect
								size="small"
								options={atendimentosSortedOptions}
								noOptionsText={`Nenhum ${labelErp} encontrado`}
								loading={loadingServices}
								value={selectedAtendimentosServices}
								open={atendimentosIsOpen}
								isOptionEqualToValue={(option, value) =>
									option.id_cliente_servico === value.id_cliente_servico
								}
								onOpen={handleOpen}
								onClose={handleClose}
								onChange={handleChange}
								inputValue={atendimentosInputValue}
								onInputChange={(_, newInputValue) =>
									setAtendimentosInputValue(newInputValue)
								}
								getOptionLabel={(option) =>
									option?.id_cliente_servico === "ALL"
										? option?.nome
										: `${option?.id_cliente_servico} - ${option?.nome}`
								}
								renderOption={(props, option, { selected }) => {
									const isAll = option?.id_cliente_servico === "ALL";
									return (
										<li {...props}>
											<Checkbox
												checked={isAll ? allSelectedAtendimentos : selected}
												style={{ marginRight: 8 }}
											/>
											<ListItemText
												primary={
													isAll
														? `Selecionar todos os ${labelErp}s`
														: `${option?.id_cliente_servico} - ${option?.nome}`
												}
											/>
										</li>
									);
								}}
								renderInput={(params) => (
									<Box sx={{ width: "100%", position: "relative" }}>
										{loadingServices && (
											<LinearProgress
												sx={{
													position: "absolute",
													top: 0,
													width: "100%",
													borderRadius: "12px 12px 0 0",
												}}
											/>
										)}
										<TextField
											{...params}
											label={`${labelErp}s`}
											placeholder={
												displayedAtendimentosValue || `Buscar ${labelErp}`
											}
											size="small"
											inputProps={{
												...params.inputProps,
												value: atendimentosIsOpen
													? atendimentosInputValue
													: displayedAtendimentosValue,
											}}
											sx={{
												"& .MuiOutlinedInput-root": {
													borderRadius: "12px",
												},
											}}
										/>
									</Box>
								)}
								renderTags={() => null}
							/>
						</Tooltip>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
}
